import { useKYCUpdateStepperContext } from 'context/KYCUpdateStepper';
import { useAppDispatch } from 'hooks';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserKYCRequest } from 'store/slices/user';

// old implementation, only need in USCountry page
const usePersonalInfoGateway = () => {
  const navigate = useNavigate();
  const [isLoadingInfo, setIsLoadingInfo] = useState(true);
  const { personalInformation, setPersonalInformation } =
    useKYCUpdateStepperContext();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const onSuccess = user => {
      setPersonalInformation({
        firstName: user.first_name ?? '',
        middleName: user.middle_name ?? '',
        lastName: user.last_name ?? '',
        houseNumber: user.address.house_number ?? '',
        streetName: user.address.street_name ?? '',
        streetType: user.address.street_type ?? '',
        unitApNumber: user.address.unit ?? '',
        city: user.address.city ?? '',
        state: user.address.state ?? '',
        zipCode: user.address.zip ?? '',
        governmentId: '',
        dateOfBirth: '',
      });
    };

    const onKYCAlreadySubmitted = () => {
      navigate('/kyc/status');
    };

    dispatch(createUserKYCRequest({ onSuccess, onKYCAlreadySubmitted }));
  }, []);

  useEffect(() => {
    if (personalInformation?.firstName && personalInformation?.lastName) {
      setIsLoadingInfo(false);
    }
  }, [personalInformation]);

  return { isLoadingInfo };
};

export default usePersonalInfoGateway;
